export enum Section {
  HERO = "HERO",
  LISTINGS = "listings",
  FEATURES = "details",
  BUY_SELL = "buy-sell",
  SERVICES = "services",
  CONTACT = "contact",
  CTA = "Call-To-Action",
}
